import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CanvasCleanupOnUnmount from '@/components/dom/modals/CanvasCleanupOnUnmount';
import { Canvas } from '@react-three/fiber';
import React, { memo, Suspense, useRef } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { IDomIdSelectors } from '../../../../typings';
import { store } from '../../../store';
import { onRemoveSelection, onSetPositions, onSetRotations, onSetScales } from '../../../store/actions';
import { BackgroundHotspot } from '../Hotspots/index';
import Scalehotspot from '../Hotspots/Scalehotspot';
import Lighting from '../r3f-components/components/Lighting/Lighting';
import RotationMarker from '../RotationMarker/RotationMarker';
import ScreenRelativeContent from './ScreenRelativeContent/ScreenRelativeContent';
export let screenRelativeCamera;
export let screenRelativeRenderer;
const ScreenRelativeCanvas = () => {
    const dispatch = useDispatch();
    const canvasRef = useRef(null);
    return (_jsxs(Canvas, { id: IDomIdSelectors.screenRelativeCanvas, style: { pointerEvents: 'auto', width: '100%', height: '100%', touchAction: 'none' }, dpr: window.devicePixelRatio, ref: canvasRef, flat: true, gl: { preserveDrawingBuffer: true }, orthographic: true, onCreated: ({ camera, gl }) => {
            screenRelativeCamera = camera;
            screenRelativeRenderer = gl;
        }, onPointerMissed: () => {
            dispatch(onRemoveSelection());
            dispatch(onSetRotations(null));
            dispatch(onSetPositions(null));
            dispatch(onSetScales(null));
            if (canvasRef.current)
                canvasRef.current.style.cursor = 'default';
        }, children: [_jsx(CanvasCleanupOnUnmount, {}), _jsx(Provider, { store: store, children: _jsxs(Suspense, { fallback: null, children: [_jsx(Lighting, {}), _jsx(ScreenRelativeContent, {}), _jsx(BackgroundHotspot, {}), _jsx(Scalehotspot, {}), _jsx(RotationMarker, {})] }) })] }));
};
export default memo(ScreenRelativeCanvas);
